import {IconProps} from "../../types/IconProps";

const ShippingAcknowledgedIcon = ({ width = 800, color = '#000' }: IconProps) => {
    return (
        <svg fill={color} height={`${width}px`} width={`${width}px`} version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                 viewBox="0 0 32 32" xmlSpace="preserve">
            <g>
                <path d="M27.3,12.1l2.4-2.4C29.9,9.5,30,9.1,30,8.8c-0.1-0.3-0.3-0.6-0.6-0.7l-10-4C19,3.9,18.6,4,18.3,4.3L16,6.6l-2.3-2.3
                    C13.4,4,13,3.9,12.6,4.1l-10,4C2.3,8.2,2.1,8.5,2,8.8C2,9.1,2.1,9.5,2.3,9.7l2.4,2.4l-2.5,3.3C2,15.6,2,16,2,16.3
                    c0.1,0.3,0.3,0.5,0.6,0.7l10,4c0.1,0,0.2,0.1,0.4,0.1c0.3,0,0.6-0.1,0.8-0.4l2.2-2.9l2.2,2.9c0.2,0.3,0.5,0.4,0.8,0.4
                    c0.1,0,0.3,0,0.4-0.1l10-4c0.3-0.1,0.5-0.4,0.6-0.7c0.1-0.3,0-0.6-0.2-0.9L27.3,12.1z M16,14.9L8.7,12L16,9.1l7.3,2.9L16,14.9z"/>
                <path d="M19,23c-0.9,0-1.8-0.4-2.4-1.2L16,21l-0.6,0.8c-0.8,1.1-2.3,1.5-3.5,1L5,20v4c0,0.4,0.2,0.8,0.6,0.9l10,4
                    c0.1,0,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1l10-4c0.4-0.2,0.6-0.5,0.6-0.9v-4l-6.9,2.8C19.8,22.9,19.4,23,19,23z"/>
            </g>
        </svg>
    );
}

export default ShippingAcknowledgedIcon;